import { useAsyncValue } from './use-async-value';
import { useEffect, useState } from 'react';
export var useInitializedState = function (init) {
    var _a = useState(null), value = _a[0], setValue = _a[1];
    var _b = useAsyncValue(init), initialValue = _b[0], loading = _b[1], error = _b[2];
    useEffect(function () {
        if (value === null && loading === false) {
            setValue(initialValue);
        }
    }, [loading]);
    return [value, setValue, loading, error];
};
//# sourceMappingURL=use-initialized-state.js.map